import type { ConfigProviderProps } from 'antd';
import {
  CalendarOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  DownOutlined,
  LoadingOutlined,
  MoreOutlined,
  PlusOutlined,
  RightOutlined,
  SearchOutlined,
} from '@/components/icon/tabler';
import { SemanticStatusIcon } from './statusIcon';

// antd 组件内部自带图标统一换成自有 Tabler 图标。
// 状态图标与 toast 共用 token 化样式:轻 tint 背板 + 线性符号,避免高饱和实心圆。
// 挂在全局 ConfigProvider,一处生效全站;rotation 型(Collapse/Menu/Tree 展开箭头)与 antd
// 未开放覆盖口的(Pagination/Popconfirm/Steps/Upload)保持原样。
const statusIcons = {
  successIcon: <SemanticStatusIcon type="success" />,
  infoIcon: <SemanticStatusIcon type="info" />,
  warningIcon: <SemanticStatusIcon type="warning" />,
  errorIcon: <SemanticStatusIcon type="error" />,
};

const close = <CloseOutlined />;
const fieldClear = <CloseOutlined />;
const loading = <LoadingOutlined spin />;

export const ANTD_ICON_CONFIG = {
  spin: { indicator: loading },
  modal: { closeIcon: close, ...statusIcons },
  alert: { closeIcon: close, ...statusIcons },
  drawer: { closeIcon: close },
  notification: { closeIcon: close },
  tour: { closeIcon: close },
  image: { preview: { closeIcon: close } },
  tabs: {
    moreIcon: <MoreOutlined />,
    addIcon: <PlusOutlined />,
    removeIcon: close,
  },
  inputSearch: { searchIcon: <SearchOutlined /> },
  select: {
    suffixIcon: <DownOutlined />,
    clearIcon: fieldClear,
    removeIcon: close,
    menuItemSelectedIcon: <CheckOutlined />,
    loadingIcon: loading,
  },
  cascader: {
    expandIcon: <RightOutlined />,
    suffixIcon: <DownOutlined />,
    clearIcon: fieldClear,
    removeIcon: close,
    searchIcon: <SearchOutlined />,
    loadingIcon: loading,
  },
  datePicker: { suffixIcon: <CalendarOutlined />, clearIcon: fieldClear },
  timePicker: { suffixIcon: <ClockCircleOutlined />, clearIcon: fieldClear },
} satisfies Partial<ConfigProviderProps>;
